import React, { InputHTMLAttributes } from "react";
import SKCustomSelect, { SKCustomOption } from "./SKCustomSelect";

interface Options {
  title: string;
  value: string | number | readonly string[] | undefined;
}
interface SelectOptionProps extends React.HTMLAttributes<HTMLDivElement> {
  //InputHTMLAttributes<HTMLSelectElement> {
  name?: string;
  index?: number;
  options: Options[];
  heading?: string;
  subHeading?: string;
  editable?: boolean;
  selectedIndex?: number;
  width?: string;
  value?: string;
  marginBottom?: string;
  textFont?: string;
  isTitleSpace?: boolean;
  placeholder?: string;
  onUpdate: (event: { target: { name: string; value: string } }) => void;
}

export const SKSelectOption = ({
  index,
  options,
  heading,
  subHeading,
  editable = true,
  selectedIndex = 1,
  width = "w-8/12",
  value,
  marginBottom = "mb-[0px]",
  textFont = "notes_inner_page !my-[0px]",
  isTitleSpace = false,
  placeholder,
  onUpdate,
  ...rest
}: SelectOptionProps) => {
  return (
    <div>
      <div className={`flex flex-col gap-[15px] ${marginBottom}`}>
        {(heading || subHeading) && (
          <div className="gap-[5px]">
            {heading && (
              <div className={`flex items-center ${isTitleSpace ? "pb-[5px]" : ""}`}>
                {index && <div className="content_count">{index}</div>}
                <span className="content_title">{heading}</span>
              </div>
            )}
            {subHeading && <p className={`${textFont} ${!isTitleSpace ? "pt-[5px]" : ""}`}>{subHeading}</p>}
          </div>
        )}
        <div className={`inline-flex ${width}`} tabIndex={0}>
          <SKCustomSelect
            {...rest}
            disabled={!editable}
            value={options.find(obj => obj.value === value)?.title ?? undefined}
            placeholder={placeholder}
            onOptionSelect={e => onUpdate(e)}
          >
            {options.map((data, index) => (
              <SKCustomOption key={data.title} value={data.value} selected={index === selectedIndex}>
                {data.title}
              </SKCustomOption>
            ))}
          </SKCustomSelect>
        </div>
      </div>
    </div>
  );
};
